module.exports = __webpack_public_path__ + "static/media/bg-pattern-intro-left-mobile.562149a8.svg";